<template>
  <div>
    <v-card class="mb-4">
      <v-card-title class="d-flex flex-wrap align-center">
        <div>
          <div class="text-h6">{{ $t('tags.title') }}</div>
          <div class="text-caption grey--text">{{ $t('tags.subtitle') }}</div>
        </div>
        <v-spacer></v-spacer>
        <v-select
          v-if="shkollat.length > 1"
          v-model="shkollaId"
          :items="shkollat"
          item-text="name"
          item-value="id"
          :label="$t('tags.school')"
          dense
          outlined
          hide-details
          style="max-width: 260px"
          class="mt-2 mt-sm-0"
          @change="ndrysho"
        ></v-select>

      </v-card-title>

      <v-card-text>
        <v-alert
          v-if="!moduliNdezur"
          type="info"
          text
          dense
          class="mb-0"
        >
          {{ eshteAdmin ? $t('tags.module_off_admin') : $t('tags.module_off') }}
        </v-alert>
        <v-row v-else dense>
          <v-col cols="6" sm="3">
            <div class="numri">{{ nxenesit.length }}</div>
            <div class="etiketa">{{ $t('tags.total_students') }}</div>
          </v-col>
          <v-col cols="6" sm="3">
            <div class="numri success--text">{{ meEtikete }}</div>
            <div class="etiketa">{{ $t('tags.with_tag') }}</div>
          </v-col>
          <v-col cols="6" sm="3">
            <div class="numri" :class="paEtikete ? 'warning--text' : ''">{{ paEtikete }}</div>
            <div class="etiketa">{{ $t('tags.without_tag') }}</div>
          </v-col>
          <v-col cols="6" sm="3">
            <div class="numri">{{ nextMinor }}</div>
            <div class="etiketa">{{ $t('tags.next_number') }}</div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card v-if="moduliNdezur">
      <v-card-text>
        <v-row dense align="center">
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="kerkimi"
              :label="$t('tags.search')"
              prepend-inner-icon="mdi-magnify"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-btn-toggle v-model="filtri" dense mandatory>
              <v-btn small value="all">{{ $t('tags.filter_all') }}</v-btn>
              <v-btn small value="without">{{ $t('tags.filter_without') }}</v-btn>
              <v-btn small value="with">{{ $t('tags.filter_with') }}</v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>

        <v-data-table
          :headers="kolonat"
          :items="teFiltruarit"
          :loading="duke"
          :items-per-page="25"
          class="mt-3"
        >
          <template #[`item.tag`]="{ item }">
            <v-chip v-if="item.tag" small color="#2E7D32" dark>
              <v-icon left small>mdi-bluetooth</v-icon>
              {{ item.tag.label || item.tag.minor }}
            </v-chip>
            <span v-else class="grey--text">—</span>
          </template>

          <template #[`item.assigned`]="{ item }">
            <span v-if="item.tag">{{ data(item.tag.assigned_at) }}</span>
            <span v-else class="grey--text">—</span>
          </template>

          <template #[`item.actions`]="{ item }">
            <v-btn v-if="!item.tag" small text color="primary" @click="hapCaktimin(item)">
              {{ $t('tags.assign') }}
            </v-btn>
            <template v-else>
              <v-btn small text @click="hapCaktimin(item)">{{ $t('tags.replace') }}</v-btn>
              <v-btn small text color="error" @click="terhiq(item)">{{ $t('tags.revoke') }}</v-btn>
            </template>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogu" max-width="440">
      <v-card v-if="perCaktim">
        <v-card-title>{{ $t('tags.assign_to') }} {{ perCaktim.name }}</v-card-title>
        <v-card-text>
          <p class="text-caption grey--text mb-4">{{ $t('tags.assign_help') }}</p>
          <v-text-field
            v-model.number="minor"
            :label="$t('tags.number')"
            type="number"
            min="1"
            max="65535"
            outlined
            dense
            autofocus
          ></v-text-field>
          <v-text-field
            v-model="label"
            :label="$t('tags.label')"
            :hint="$t('tags.label_hint')"
            persistent-hint
            outlined
            dense
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogu = false">{{ $t('actions.cancel') }}</v-btn>
          <v-btn color="primary" :loading="duke" @click="ruaj">{{ $t('actions.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/**
 * Caktimi i etiketave Bluetooth te nxenesve.
 *
 * Faqja punon mbi nxenesit e jo mbi etiketat, sepse pyetja e perditshme eshte
 * "kush ka mbetur pa etikete". Kodi i etiketes shfaqet ketu — kjo eshte faqja
 * e shkolles; nxenesi vete nuk e sheh kurre.
 */
import axios from 'axios';
import auth from '@/services/AuthService';
import { mesazhiIGabimit } from '@/utils/error-message';

export default {
  data() {
    return {
      shkollat: [],
      shkollaId: null,
      nxenesit: [],
      nextMinor: 1,
      kerkimi: '',
      filtri: 'all',
      duke: false,
      dialogu: false,
      perCaktim: null,
      // null derisa te vije pergjigjja: pa kete do te pulsonte njoftimi
      // "i fikur" per nje cast edhe atje ku eshte i ndezur.
      moduliNdezur: true,
      minor: null,
      label: '',
    };
  },
  computed: {
    eshteAdmin() {
      return auth.getLoggedInUserRole() === 'admin';
    },
    kolonat() {
      return [
        { text: this.$t('tags.student'), value: 'name' },
        { text: this.$t('tags.number_col'), value: 'number' },
        { text: this.$t('tags.tag'), value: 'tag', sortable: false },
        { text: this.$t('tags.assigned'), value: 'assigned', sortable: false },
        { text: '', value: 'actions', sortable: false, align: 'end' },
      ];
    },
    meEtikete() {
      return this.nxenesit.filter(n => n.tag).length;
    },
    paEtikete() {
      return this.nxenesit.length - this.meEtikete;
    },
    teFiltruarit() {
      const q = (this.kerkimi || '').toLowerCase().trim();

      return this.nxenesit.filter(n => {
        if (this.filtri === 'with' && !n.tag) return false;
        if (this.filtri === 'without' && n.tag) return false;
        if (!q) return true;

        return (n.name || '').toLowerCase().includes(q)
          || String(n.number || '').toLowerCase().includes(q);
      });
    },
  },
  mounted() {
    this.merrShkollat();
  },
  methods: {
    data(v) {
      return v ? new Date(v).toLocaleDateString() : '';
    },

    async merrShkollat() {
      try {
        const { data } = await axios.get('/student-tags/schools');
        this.shkollat = data.schools || [];
        if (this.shkollat.length) {
          this.shkollaId = this.shkollat[0].id;
          await this.ndrysho();
        }
      } catch (e) {
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      }
    },

    /** Ndryshimi i shkolles sjell edhe gjendjen e modulit, edhe nxenesit. */
    async ndrysho() {
      await this.merrModulin();
      if (this.moduliNdezur) await this.merrNxenesit();
    },

    async merrModulin() {
      try {
        const { data } = await axios.get('/student-tags/module', {
          params: { school_id: this.shkollaId },
        });
        this.moduliNdezur = !!data.enabled;
      } catch (e) {
        this.moduliNdezur = false;
      }
    },


    async merrNxenesit() {
      if (!this.shkollaId) return;
      this.duke = true;
      try {
        const { data } = await axios.get('/student-tags/students', {
          params: { school_id: this.shkollaId },
        });
        this.nxenesit = data.students || [];
        this.nextMinor = data.next_minor || 1;
      } catch (e) {
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      } finally {
        this.duke = false;
      }
    },

    hapCaktimin(nxenesi) {
      this.perCaktim = nxenesi;
      // Numri i radhes vjen i plotesuar: sekretaria e ndryshon vetem nese
      // etiketa ne dore ka tjeter numer te shtypur.
      this.minor = nxenesi.tag ? nxenesi.tag.minor : this.nextMinor;
      this.label = nxenesi.tag ? nxenesi.tag.label || '' : '';
      this.dialogu = true;
    },

    async ruaj() {
      if (!this.minor) return;
      this.duke = true;
      try {
        await axios.post('/student-tags', {
          student_id: this.perCaktim.id,
          school_id: this.shkollaId,
          minor: this.minor,
          label: this.label || null,
        });
        this.dialogu = false;
        await this.merrNxenesit();
      } catch (e) {
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      } finally {
        this.duke = false;
      }
    },

    async terhiq(nxenesi) {
      if (!window.confirm(this.$t('tags.revoke_confirm', { name: nxenesi.name }))) return;

      this.duke = true;
      try {
        // Lista e nxenesve nuk e mban id-ne e etiketes, ndaj merret ajo
        // aktive e ketij nxenesi.
        const { data } = await axios.get('/student-tags', {
          params: { student_id: nxenesi.id, school_id: this.shkollaId },
        });
        const e = (data.tags || [])[0];
        if (e) await axios.delete(`/student-tags/${e.id}`);
        await this.merrNxenesit();
      } catch (err) {
        this.$notify({ title: 'Error', text: mesazhiIGabimit(err), type: 'error' });
      } finally {
        this.duke = false;
      }
    },
  },
};
</script>

<style scoped>
.numri {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.1;
}
.etiketa {
  font-size: 0.75rem;
  color: #78909c;
}
</style>
